import _baseSlice_default from "./_baseSlice.js";

//#region ../../node_modules/lodash-es/_castSlice.js
/**
* Casts `array` to a slice if it's needed.
*
* @private
* @param {Array} array The array to inspect.
* @param {number} start The start position.
* @param {number} [end=array.length] The end position.
* @returns {Array} Returns the cast slice.
*/
function castSlice(array, start, end) {
	var length = array.length;
	end = end === void 0 ? length : end;
	return !start && end >= length ? array : _baseSlice_default(array, start, end);
}
var _castSlice_default = castSlice;

//#endregion
export { _castSlice_default as default };
//# sourceMappingURL=_castSlice.js.map